import { type RouteLocation } from 'vue-router';
import { setCookie } from '~~/package/utils/CookieUtil';
import { CookieKeyType } from '~~/package/mapper/common/model/CookieKeyType';
import { ManagerRouteName } from '~~/package/enum/ManagerRouteName';

/**
 * Remembers where to come back after login (read by userStore.moveToRedirectUrl on /sign and
 * /auth/user/social). Valid for 24h.
 */
export const setRedirectUrlCookie = (location: Pick<RouteLocation, 'fullPath' | 'path' | 'query' | 'name'>): void => {
    setCookie(
        CookieKeyType.REDIRECT_URL,
        {
            fullPath: location.fullPath,
            path: location.path,
            query: location.query,
            isManager: Object.values(ManagerRouteName).includes(location.name as ManagerRouteName),
        },
        { expires: new Date(Date.now() + 86400 * 1000), maxAge: 86400 }
    );
};
